import { Component, ElementRef, Inject, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalDataService } from '../shared/services/global-data.service';
import { ConflictResult } from '../shared/models/conflict-result';
import { SearchService } from '../shared/services/search.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { SnackbarService } from '../shared/services/snackbar.service';

@Component({
    selector: 'xp-search-popup',
    templateUrl: './search-popup.component.html',
    styleUrl: './search-popup.component.scss'
})
export class SearchPopupComponent {
    faFilePdf = faFilePdf;
    showProgressBar: boolean = false;
    searchText: string[] = [];
    currentTab: string = "";
    searchBtn: boolean = true;
    conflictResult: ConflictResult[] = [];
    isBtnPdfVisible: boolean = false;
    downloadPdfBtn: boolean = false;
    showResult: boolean = false;
    showProgress: boolean = false;
    hideTabs: boolean = false;
    searchForms: { text: string }[] = [{ text: '' }];
    searchFields: string[] = [];
    @ViewChildren('searchInput') searchInputs!: QueryList<ElementRef>;

    constructor(
        private dialogRef: MatDialogRef<SearchPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { searchText: string, searchFields: string[], }, 

        public globalDataSharing: GlobalDataService,
        private searchService: SearchService,
        private snackBar: SnackbarService) 
    {
        this.currentTab = globalDataSharing._currentTab;
        this.searchText = data.searchText ? data.searchText.split(' OR ').map(s => s.trim()) : [''];
        this.searchFields = data?.searchFields?.length ? [...data.searchFields] : [''];
    }

    closeDialog(): void {
        this.dialogRef.close({
            searchText: this.searchText,
            searchFields: this.searchFields
        });
    }

    search(currentTab: string) {
        this.conflictResult = [];
        this.isBtnPdfVisible = false;
        this.downloadPdfBtn = false;
       
        if (currentTab == "ConflictCheck") {
            if (this.validateSearchText()) {
                this.searchService.conflictSearchTerm = this.searchText
                this.showResult = true;
                this.searchService.searchClick.next(true);
                this.closeDialog();
            }
            else {
                this.showProgress = false;
                this.snackBar.errorSnackBar("Invalid Search Term");
                this.searchText = [];
            }
        }
    }

    validateSearchText(): boolean {
        if (!Array.isArray(this.searchText) || this.searchText.length === 0) {
            return false; // Reject if searchText is not an array or is empty
        }
    
        // Trim each element and remove empty values
        this.searchText = this.searchText
            .map(text => text.trim())
            .filter(text => text !== "" && !/^[,\s]+$/.test(text)); // Remove spaces/commas-only strings
    
        if (this.searchText.length === 0) {
            return false; // Reject if all elements were blank or only commas/spaces
        }

        const allowedPatterns = [
            /^[\x20-\x7E\u0080-\uFFFF]+$/,                                  // Any printable ASCII characters
            /^[\x20-\x7E\u0080-\uFFFF]+\*$/,                                // Text* with any printable ASCII characters
            /^".*"$/,                                                       // "Text" (Quotes can still be used)
            /^[\x20-\x7E\u0080-\uFFFF]+ OR [\x20-\x7E\u0080-\uFFFF]+$/,     // textA OR textB with any printable characters
            /^[\x20-\x7E\u0080-\uFFFF]+ or [\x20-\x7E\u0080-\uFFFF]+$/,     // textA or textB with any printable characters
            /^[\x20-\x7E\u0080-\uFFFF]+ AND [\x20-\x7E\u0080-\uFFFF]+$/,    // textA AND textB with any printable characters
            /^[\x20-\x7E\u0080-\uFFFF]+ and [\x20-\x7E\u0080-\uFFFF]+$/,    // textA and textB with any printable characters
            /^[\x20-\x7E\u0080-\uFFFF\s]+$/,                                // Text with spaces and printable ASCII characters
            /^[\x20-\x7E\u0080-\uFFFF\s]+\*$/,                              // Text with spaces and asterisk with printable ASCII characters
        ];

        for (let index = 0; index < allowedPatterns.length; index++) {
            var isValid = allowedPatterns[index].test(this.searchText.join( 'OR' ));
            if (isValid) {
                return true;
            }
        }
        return false
    }

    addSearchField() {
        this.searchFields.push('');
        this.searchText.push('');
    }

    removeSearchField(index: number) {
        if (this.searchFields.length > 1) {
            this.searchFields.splice(index, 1);
            this.searchText.splice(index, 1);
        }
    }

    onInputChange(index: number) {
        // If the last input field is being typed in and we have fewer than 6 fields
        if (index === this.searchFields.length - 1 && this.searchFields.length < 6) {
            this.searchFields.push('');
            // this.searchText.push('');
        }
    }
}
